import { atom } from "jotai";

export const globalNavOpenAtom = atom<boolean>(false);
